import { createFileRoute } from '@tanstack/react-router'

import { useCreateSalesChannelGroup } from '@/api/api-mutations'
import { Button } from '@/components/base/button'
import { Drawer } from '@/components/base/drawer'
import { Heading } from '@/components/base/heading'
import { toast, useCreatedToast } from '@/components/base/toast'
import { FormContainer, FormFieldGroup, useAppForm } from '@/components/form/form'
import { RouteModal, RouteModalFormBlocker, useRouteModal } from '@/components/route-modal'
import { useI18n } from '@/i18n/i18n-react'

export const Route = createFileRoute('/_authenticated/settings/sales-channels/groups/create')({
	component: RouteComponent,
	staticData: {
		crumb: ({ context: { L } }) => L.Settings.SalesChannels.Groups.CreateTitle()
	}
})

function RouteComponent() {
	return (
		<RouteModal prev='..' asDrawer>
			<NewSalesChannelGroupForm />
		</RouteModal>
	)
}

function NewSalesChannelGroupForm() {
	const { L } = useI18n()
	const { handleSuccess } = useRouteModal()
	const createdToast = useCreatedToast()
	const createSalesChannelGroup = useCreateSalesChannelGroup()

	const form = useAppForm({
		defaultValues: { name: '' },
		onSubmit: async ({ value }) => {
			const result = await createSalesChannelGroup({ body: { name: value.name } })
			if (result.isSuccess) {
				createdToast(L.Settings.SalesChannels.Groups.CreateSuccess(), {
					to: '/settings/sales-channels/groups/$groupUuid',
					params: { groupUuid: result.response.uuid }
				})
				handleSuccess()
			} else {
				toast.error((result.response as any)?.message ?? L.Error.SomethingWentWrong())
			}
		}
	})

	return (
		<form.AppForm>
			<RouteModalFormBlocker form={form as any} />
			<Drawer.Header>
				<Drawer.Title asChild>
					<Heading>{L.Settings.SalesChannels.Groups.CreateTitle()}</Heading>
				</Drawer.Title>
			</Drawer.Header>
			<Drawer.Body className='flex-1 overflow-auto'>
				<FormContainer>
					<FormFieldGroup>
						<form.AppField
							name='name'
							validators={{ onChange: ({ value }) => (!value ? L.General.Required() : undefined) }}
							children={field => (
								<field.TextField
									autoFocus
									label={L.Fields.Name()}
									placeholder={L.Settings.SalesChannels.Groups.NamePlaceholder()}
								/>
							)}
						/>
					</FormFieldGroup>
				</FormContainer>
			</Drawer.Body>
			<Drawer.Footer>
				<div className='flex items-center justify-end gap-x-2'>
					<Drawer.Close asChild>
						<Button variant='secondary' size='small'>
							{L.General.Cancel()}
						</Button>
					</Drawer.Close>
					<form.CreateButton />
				</div>
			</Drawer.Footer>
		</form.AppForm>
	)
}
